import { MEETING_TICKET_KEY } from '@/modules/Ticket/constants'
import { TFunction } from 'i18next'
import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Alert, FormItem } from 'vnetwork-ui'

interface Props {
    control: Control<any>
    ticketTypeKey?: string
}

// Meeting purpose options based on API documentation
const MEETING_PURPOSE_OPTIONS = (t: TFunction) => [
    { label: t('meeting-purpose-presale'), value: 'presale_presentation' },
    { label: t('meeting-purpose-support'), value: 'support' },
]

const TicketMeeting: React.FC<Props> = ({ control, ticketTypeKey }) => {
    const { t } = useTranslation()

    return (
        <div className="space-y-4">
            {ticketTypeKey !== MEETING_TICKET_KEY && (
                <FormItem
                    name="ticket_meeting_type"
                    control={control}
                    label={t('ticket-meeting-via-label')}
                    options={[
                        { label: 'Online', value: 'online' },
                        { label: 'Offline', value: 'offline' },
                    ]}
                    allowClear={false}
                    type="select"
                    size="small"
                />
            )}
            {ticketTypeKey === MEETING_TICKET_KEY && (
                <>
                    <Alert variant="info">
                        {t('ticket-meeting-purpose-notice')}
                    </Alert>
                    <FormItem
                        name="ticket_meeting_purpose"
                        control={control}
                        label={t('ticket-meeting-purpose-label')}
                        type="select"
                        size="small"
                        allowClear={false}
                        options={MEETING_PURPOSE_OPTIONS(t)}
                    />
                </>
            )}
            <FormItem
                name="ticket_meeting_channel"
                control={control}
                label={t('ticket-meeting-channel-placeholder')}
                type="select"
                allowClear={false}
                placeholder={t('ticket-meeting-channel-placeholder')}
                options={[
                    { label: 'Zoom', value: 'zoom' },
                    { label: 'Google Meet', value: 'google-meet' },
                    { label: 'Microsoft Teams', value: 'microsoft-teams' },
                    { label: 'Other', value: 'other' },
                ]}
            />
            <FormItem
                name="ticket_meeting_via"
                control={control}
                label={t('ticket-meeting-via-placeholder')}
                type="textfield"
                placeholder={t('ticket-meeting-via-placeholder')}
                helperText={t('ticket-meeting-via-helper-text')}
            />
        </div>
    )
}

export default TicketMeeting
